<div id="{{ random }}">
    <div class="therm outer-therm">
        <div class="proggress">
            <div class="therm inner-therm">
                
            </div>
        </div>
    </div>
</div>